export default __webpack_public_path__ + "static/17_36-5de143ef16e604710ec43040d968b17f.png";